import type { ProductType } from '@fig/shared';

export const FIG_PRODUCT_TYPE_OPTIONS = [
  'Annuity',
  'Deferred Income Annuity',
  'Fixed Annuity Products',
  'Fixed Immediate Annuity',
  'Fixed Indexed Annuity',
  'Indexed Annuity',
  'Registered Indexed Annuity',
  'Single Premium Immediate Annuity',
  'Unknown',
  'Variable Annuity Products',
  'Variable Immediate Annuity',
  'Variable Indexed Annuity',
] as const satisfies readonly ProductType[];

const FIG_PRODUCT_TYPE_SET = new Set<string>(FIG_PRODUCT_TYPE_OPTIONS);

const LEGACY_PRODUCT_TYPE_TO_FIG_PRODUCT_TYPE: Record<string, ProductType> = {
  FIA: 'Fixed Indexed Annuity',
  MYGA: 'Fixed Annuity Products',
  VA: 'Variable Annuity Products',
  Fixed: 'Fixed Annuity Products',
  VIA: 'Variable Indexed Annuity',
  RILA: 'Registered Indexed Annuity',
  'Fixed Annuity': 'Fixed Annuity Products',
  'Variable Annuity': 'Variable Annuity Products',
};

export function isFigProductType(value: string | null | undefined): value is ProductType {
  return typeof value === 'string' && FIG_PRODUCT_TYPE_SET.has(value);
}

export function normalizeProductTypeLabel(value: string | null | undefined): ProductType {
  const trimmed = value?.trim();
  if (!trimmed) return 'Unknown';
  if (isFigProductType(trimmed)) return trimmed;

  const legacyMatch = Object.entries(LEGACY_PRODUCT_TYPE_TO_FIG_PRODUCT_TYPE).find(
    ([legacy]) => legacy.toUpperCase() === trimmed.toUpperCase()
  );
  if (legacyMatch) return legacyMatch[1];

  const upper = trimmed.toUpperCase();
  if (upper.includes('REGISTERED') && upper.includes('INDEX')) {
    return 'Registered Indexed Annuity';
  }
  if (upper.includes('VARIABLE') && upper.includes('INDEX')) {
    return 'Variable Indexed Annuity';
  }
  if (upper.includes('VARIABLE')) {
    return 'Variable Annuity Products';
  }
  if (upper.includes('SINGLE PREMIUM') && upper.includes('IMMEDIATE')) {
    return 'Single Premium Immediate Annuity';
  }
  if (upper.includes('DEFERRED') && upper.includes('INCOME')) {
    return 'Deferred Income Annuity';
  }
  if (upper.includes('IMMEDIATE')) {
    return 'Fixed Immediate Annuity';
  }
  if (upper.includes('FIXED') && upper.includes('INDEX')) {
    return 'Fixed Indexed Annuity';
  }
  if (upper.includes('INDEX')) {
    return 'Indexed Annuity';
  }
  if (upper.includes('FIXED')) {
    return 'Fixed Annuity Products';
  }

  return 'Unknown';
}
